import React from 'react';
import { useSelector } from 'react-redux';

import { Grid } from '@material-ui/core';
import { useActionDispatcher } from '../../hooks';
import { saveUserRequest } from '../../store/modules/users/actions';
import { selectUser } from '../../store/modules/users/selectors';
import { FormUserNotifications } from '../../components';
import Spinner from '../../components/spinner/Spinner';
import useStyles from '../../components/item-form/styles';

const UserNotifications = () => {
  const user = useSelector(selectUser);
  const classes = useStyles();
  const saveCurrentUser = useActionDispatcher(saveUserRequest);

  if (user?.loading) {
    return (
      <Grid container className={classes.spinnerWrapper}>
        <Spinner />
      </Grid>
    );
  }

  return (
    <FormUserNotifications
      currentMode
      record={user}
      onSubmit={saveCurrentUser}
      preventCancelChanges
    />
  );
};

export default UserNotifications;
